import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const AppConfigContext = createContext(null);
export function AppConfigProvider({ config, children, }) {
    return (_jsx(AppConfigContext.Provider, { value: config, children: children }));
}
/** A configuração da aplicação. Só dentro do `TeamsKitApp`. */
export function useAppConfig() {
    const config = useContext(AppConfigContext);
    if (config === null) {
        throw new Error('useAppConfig fora do TeamsKitApp');
    }
    return config;
}
//# sourceMappingURL=app-config.js.map